// import React, { useState, useEffect, useLayoutEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import Header from './Layouts/Header';
// import Footer from './Layouts/Footer';
// import { getCart, checkout, placeOrder } from '../utils/apiService';

// const Checkout = () => {
//     const navigate = useNavigate();

//     // Form state
//     const [formData, setFormData] = useState({
//         first_name: '',
//         last_name: '',
//         email: '',
//         phone: '',
//         address: '',
//         postal_code: '',
//         city: '',
//         state: 'State',
//         country: 'Country',
//         order_notes: ''
//     });

//     // Order state
//     const [orderItems, setOrderItems] = useState([]);
//     const [loading, setLoading] = useState(true);
//     // const [shipping, setShipping] = useState(200);
//     const [taxRate, setTaxRate] = useState(0);
//     const [paymentMethod, setPaymentMethod] = useState('cod');

//     const token = localStorage.getItem('token');

//     const fetchCartAndUserData = async () => {
//         if (!token) {
//             setLoading(false);
//             navigate('/login');
//             return;
//         }
//         try {
//             // Fetch cart data
//             const cartResult = await getCart(token);
//             if (cartResult && cartResult.status) {
//                 const cartData = cartResult.data || [];
//                 const items = Array.isArray(cartData) ? cartData : (cartData.items && Array.isArray(cartData.items) ? cartData.items : []);
//                 setOrderItems(items);
//                 if (cartData.tax_rate !== undefined) {
//                     setTaxRate(Number(cartData.tax_rate));
//                 }
//             }

//             // Fetch user billing details
//             const userResult = await checkout(token);
//             console.log(token);
//             if (userResult && userResult.status && userResult.data && userResult.data.user) {
//                 const user = userResult.data.user;
//                 console.log(user);
//                 setFormData(prev => ({
//                     ...prev,
//                     first_name: user.first_name || '',
//                     last_name: user.last_name || '',
//                     email: user.email || '',
//                     phone: user.phone || '',
//                     address: user.address || '',
//                     postal_code: user.zipcode || '', // Map zipcode from checkout to postal_code
//                     city: user.city || '',
//                     state: user.state || 'State',
//                     country: user.country || 'Country'
//                 }));
//             }
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchCartAndUserData();
//     }, [token, navigate]);

//     // Calculate total
//     const calculateSubtotal = () => {
//         return orderItems.reduce((sum, item) => sum + (Number(item.price) || 0) * (item.quantity || 0), 0);
//     };

//     const calculateTax = () => {
//         return Math.round(calculateSubtotal() * (taxRate / 100));
//     };

//     const calculateTotal = () => {
//         return calculateSubtotal() + calculateTax();

//         // return calculateSubtotal() + calculateTax() + shipping;
//     };

//     // Handle input changes
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     // Handle form submission
//     const handleSubmit = async (e) => {
//         if (e) e.preventDefault();

//         if (orderItems.length === 0) {
//             toast.warning('Your cart is empty');
//             return;
//         }

//         const payload = {
//             ...formData,
//             items: orderItems,
//             total: calculateTotal(),
//             payment_method: paymentMethod
//         };

//         console.log('Submitting order:', payload);

//         try {
//             const result = await placeOrder(payload, token);
//             if (result && result.status) {
//                 toast.success('Order placed successfully!');
//                 window.dispatchEvent(new CustomEvent('cartUpdated')); // Sync header count
//                 navigate('/orderhistory'); // Redirect to order history
//             } else {
//                 toast.error(result.message || 'Failed to place order');
//             }
//         } catch (error) {
//             console.error('Error placing order:', error);
//             toast.error('Failed to place order. Please try again later.');
//         }
//     };

//     // Animation effects
//     useLayoutEffect(() => {
//         const timer = setTimeout(() => {
//             if (window.animationText) window.animationText();
//             if (window.scrollingEffect) window.scrollingEffect();
//             if (window.animateImgItem) window.animateImgItem();

//             if (window.ScrollTrigger) {
//                 window.ScrollTrigger.refresh();
//             }
//         }, 100);

//         return () => {
//             clearTimeout(timer);
//             if (window.revertAnimations) window.revertAnimations();
//             if (window.revertHeadline) window.revertHeadline();
//         };
//     }, []);

//     return (
//         <div className="wrapper position-relative">
//             <Header />
//             {/* Background Masks */}
//             <div className="wrapper position-relative overflow-x-clip">
//                 <div className="mask mask-1">
//                     <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
//                         <circle cx="400" cy="400" r="325" stroke="url(#a6)" strokeWidth="150" />
//                         <defs>
//                             <linearGradient id="a6" x1="176" x2="569" y1="70.5" y2="674">
//                                 <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
//                                 <stop offset="1" stopColor="#fff" stopOpacity="0" />
//                             </linearGradient>
//                         </defs>
//                     </svg>
//                 </div>
//                 <div className="mask mask-2">
//                     <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
//                         <circle cx="400" cy="400" r="325" stroke="url(#e7)" strokeWidth="150" />
//                         <defs>
//                             <linearGradient id="e7" x1="176" x2="569" y1="70.5" y2="674">
//                                 <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
//                                 <stop offset="1" stopColor="#fff" stopOpacity="0" />
//                             </linearGradient>
//                         </defs>
//                     </svg>
//                 </div>
//             </div>

//             {/* Page Title */}
//             <div className="page-title">
//                 <div className="tf-container">
//                     <div className="page-title-content text-center">
//                         <h1 className="title">
//                             <span className="split-text effect-right">Checkout</span>
//                         </h1>
//                         <div className="breadkcum">
//                             <Link to="/" className="link-breadkcum body-2 fw-7">
//                                 <span className="split-text effect-right">Home</span>
//                             </Link>
//                             <span className="dot"></span>
//                             <span className="page-breadkcum body-2 fw-7">
//                                 <span className="split-text effect-right">Checkout</span>
//                             </span>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Main Content */}
//             <div className="main-content">
//                 <section className="section-team p-team tf-spacing-2">
//                     <div className="tf-container">
//                         <div className="row rg-30">
//                             {/* Billing Details */}
//                             <div className="col-lg-7">
//                                 <div className="checkout-box">
//                                     <div className="checkout-title">Billing Details</div>
//                                     <form
//                                         className="form-contact-us form-billing-us style-bg-dark-2 px-md-15"
//                                         method="post"
//                                         onSubmit={handleSubmit}
//                                         noValidate
//                                     >
//                                         {/* Name Fields */}
//                                         <div className="cols mb-37 g-30">
//                                             <fieldset className="item">
//                                                 <fieldset className="position-relative">
//                                                     <i className="icon-user"></i>
//                                                     <input
//                                                         type="text"
//                                                         name="first_name"
//                                                         id="name"
//                                                         placeholder="First Name"
//                                                         value={formData.first_name}
//                                                         onChange={handleInputChange}
//                                                         required
//                                                     />
//                                                 </fieldset>
//                                             </fieldset>

//                                             <fieldset className="item">
//                                                 <fieldset className="position-relative">
//                                                     <i className="icon-user"></i>
//                                                     <input
//                                                         type="text"
//                                                         name="last_name"
//                                                         id="lname"
//                                                         placeholder="Last Name"
//                                                         value={formData.last_name}
//                                                         onChange={handleInputChange}
//                                                         required
//                                                     />
//                                                 </fieldset>
//                                             </fieldset>
//                                         </div>

//                                         {/* Email and Phone */}
//                                         <div className="cols mb-37 g-30">
//                                             <fieldset className="item">
//                                                 <fieldset className="position-relative">
//                                                     <i className="icon-email"></i>
//                                                     <input
//                                                         type="email"
//                                                         name="email"
//                                                         id="mail"
//                                                         placeholder="Email Address"
//                                                         value={formData.email}
//                                                         onChange={handleInputChange}
//                                                         required
//                                                     />
//                                                 </fieldset>
//                                             </fieldset>

//                                             <fieldset className="item">
//                                                 <fieldset className="position-relative">
//                                                     <i className="icon-phone"></i>
//                                                     <input
//                                                         type="number"
//                                                         name="phone"
//                                                         id="phone"
//                                                         placeholder="Phone Number"
//                                                         value={formData.phone}
//                                                         onChange={handleInputChange}
//                                                         required
//                                                     />
//                                                 </fieldset>
//                                             </fieldset>
//                                         </div>

//                                         {/* Address */}
//                                         <div className="cols mb-37 g-30">
//                                             <fieldset className="item">
//                                                 <fieldset className="position-relative">
//                                                     <i className="fa-regular fa-map"></i>
//                                                     <input
//                                                         type="text"
//                                                         name="address"
//                                                         id="address"
//                                                         placeholder="Street Address"
//                                                         value={formData.address}
//                                                         onChange={handleInputChange}
//                                                         required
//                                                     />
//                                                 </fieldset>
//                                             </fieldset>
//                                         </div>

//                                         {/* Zip and City */}
//                                         <div className="cols mb-37 g-30">
//                                             <fieldset className="item">
//                                                 <fieldset className="position-relative">
//                                                     <i className="icon-phone"></i>
//                                                     <input
//                                                         type="number"
//                                                         name="postal_code"
//                                                         id="zip"
//                                                         placeholder="Zip/Postal Code"
//                                                         value={formData.postal_code}
//                                                         onChange={handleInputChange}
//                                                         required
//                                                     />
//                                                 </fieldset>
//                                             </fieldset>

//                                             <fieldset className="item">
//                                                 <fieldset className="position-relative">
//                                                     <i className="fa-solid fa-city"></i>
//                                                     <input
//                                                         type="text"
//                                                         name="city"
//                                                         id="city"
//                                                         placeholder="City"
//                                                         value={formData.city}
//                                                         onChange={handleInputChange}
//                                                         required
//                                                     />
//                                                 </fieldset>
//                                             </fieldset>
//                                         </div>

//                                         {/* State and Country Selects */}
//                                         <div className="cols mb-37 g-30">
                                            
//                                             <fieldset className="item">
//                                                 <select
//                                                     name="country"
//                                                     id="country"
//                                                     value={formData.country}
//                                                     onChange={handleInputChange}
//                                                     className="nice-select w-100"
//                                                 >
//                                                     <option value="Country">Country</option>
//                                                     <option value="India">India</option>
//                                                 </select>
//                                             </fieldset>
//                                             <fieldset className="item">
//                                                 <select
//                                                     name="state"
//                                                     id="state"
//                                                     value={formData.state}
//                                                     onChange={handleInputChange}
//                                                     className="nice-select w-100"
//                                                 >
//                                                     <option value="State">State</option>
//                                                     <option value="Gujarat">Gujarat</option>
//                                                     <option value="Bihar">Bihar</option>
//                                                     <option value="Panjab">Panjab</option>
//                                                 </select>
//                                             </fieldset>

//                                         </div>

//                                         {/* Order Notes */}
//                                         <fieldset className="">
//                                             <textarea
//                                                 name="order_notes"
//                                                 id="notes"
//                                                 placeholder="Order Notes (Optional)"
//                                                 value={formData.order_notes}
//                                                 onChange={handleInputChange}
//                                             />
//                                         </fieldset>
//                                     </form>
//                                 </div>
//                             </div>

//                             {/* Order Summary */}
//                             <div className="col-lg-5">
//                                 <div className="checkout-box">
//                                     <div className="checkout-title">Your Order</div>

//                                     <div className="order-summary">
//                                         {loading ? (
//                                             <div className="text-center py-3">Loading order details...</div>
//                                         ) : orderItems.length === 0 ? (
//                                             <div className="text-center py-3">Your cart is empty</div>
//                                         ) : (
//                                             <>
//                                                 {orderItems.map(item => (
//                                                     <div key={item.id} className="order-item">
//                                                         <span>{item.name} × {item.quantity}</span>
//                                                         <span>₹{(Number(item.price) * item.quantity).toLocaleString()}</span>
//                                                     </div>
//                                                 ))}
//                                                 <div className="order-item">
//                                                     <span>Tax ({taxRate}%)</span>
//                                                     <span>₹{calculateTax().toLocaleString()}</span>
//                                                 </div>
//                                                 {/* <div className="order-item">
//                                                     <span>Shipping</span>
//                                                     <span>₹{shipping.toLocaleString()}</span>
//                                                 </div> */}
//                                                 <div className="order-item total">
//                                                     <span>Total</span>
//                                                     <span>₹{calculateTotal().toLocaleString()}</span>
//                                                 </div>
//                                             </>
//                                         )}
//                                     </div>

//                                     {/* Payment Method */}
//                                     <div className="payment-method mt-4">
//                                         <label>
//                                             <input
//                                                 type="radio"
//                                                 name="payment"
//                                                 checked={paymentMethod === 'cod'}
//                                                 onChange={() => setPaymentMethod('cod')}
//                                             />
//                                             <i className="fa-solid fa-money-bill-wave"></i>
//                                             Cash on Delivery
//                                         </label>

//                                         {/* <label>
//                                             <input type="radio" name="payment" />
//                                             <i className="fa-brands fa-cc-visa"></i>
//                                             Credit / Debit Card
//                                         </label>

//                                         <label>
//                                             <input type="radio" name="payment" />
//                                             <i className="fa-brands fa-google-pay"></i>
//                                             UPI / Wallet
//                                         </label> */}
//                                     </div>

//                                     {/* Place Order Button */}
//                                     <button
//                                         type="submit"
//                                         onClick={handleSubmit}
//                                         className="tf-btn style-bg-primary w-full justify-content-center mt-5"
//                                     >
//                                         <span>Place Order</span>
//                                         <i className="icon-arrow-right"></i>
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//             </div>

//             <Footer />
//         </div>
//     );
// };

// export default Checkout;

import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import { getCart, checkout, placeOrder, fetchCountries, fetchStates } from '../utils/apiService';

const Checkout = () => {
    const navigate = useNavigate();

    // Form state
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        address: '',
        postal_code: '',
        city: '',
        state: '',
        country: '',
        order_notes: ''
    });

    // Order state
    const [orderItems, setOrderItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [taxRate, setTaxRate] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('cod');

    // Countries and States
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [loadingCountries, setLoadingCountries] = useState(true);
    const [loadingStates, setLoadingStates] = useState(false);

    const token = localStorage.getItem('token');
    const [currency, setCurrency] = useState('$'); // fallback default

    // Fetch countries on component mount
    useEffect(() => {
        const loadCountries = async () => {
            setLoadingCountries(true);
            const result = await fetchCountries(token);
            
            if (result && result.status && result.data) {
                setCountries(result.data);
            } else {
                console.error('Failed to fetch countries');
            }
            setLoadingCountries(false);
        };

        loadCountries();
    }, [token]);


    const loadStatesForCountry = async (countryId) => {
        if (!countryId) {
            setStates([]);
            return;
        }

        setLoadingStates(true);
        const result = await fetchStates(countryId, token);
        
        if (result && result.status && result.data) {
            setStates(result.data);
        } else {
            console.error('Failed to fetch states');
            setStates([]);
        }
        setLoadingStates(false);
    };

    const fetchCartAndUserData = async () => {
        if (!token) {
            setLoading(false);
            navigate('/login');
            return;
        }
        try {
            const cartResult = await getCart(token);
            if (cartResult && cartResult.status) {
                const cartData = cartResult.data || [];
                const items = Array.isArray(cartData) ? cartData : (cartData.items && Array.isArray(cartData.items) ? cartData.items : []);
                setOrderItems(items);
                if (cartData.tax_rate !== undefined) {
                    setTaxRate(Number(cartData.tax_rate));
                }
            }
            const userResult = await checkout(token);
            console.log(token);
            if (userResult && userResult.status && userResult.data && userResult.data.user) {
                const user = userResult.data.user;
                console.log(user);
                  if (user.currency) {
                    setCurrency(user.currency);
                }
                setFormData(prev => ({
                    ...prev,
                    first_name: user.first_name || '',
                    last_name: user.last_name || '',
                    email: user.email || '',
                    phone: user.phone || '',
                    address: user.address || '',
                    postal_code: user.zipcode || '',
                    city: user.city || '',
                    state: user.state || '',
                    country: user.country || ''
                }));              
                if (user.country) {
                    loadStatesForCountry(user.country);
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCartAndUserData();
    }, [token, navigate]);

    const calculateSubtotal = () => {
        return orderItems.reduce((sum, item) => sum + (Number(item.price) || 0) * (item.quantity || 0), 0);
    };

    const calculateTax = () => {
        return Math.round(calculateSubtotal() * (taxRate / 100));
    };

    const calculateTotal = () => {
        return calculateSubtotal() + calculateTax();
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (name === 'country') {
            setFormData(prev => ({
                ...prev,
                state: '' 
            }));
            loadStatesForCountry(value);
        }
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        if (orderItems.length === 0) {
            toast.warning('Your cart is empty');
            return;
        }

        if (!formData.country) {
            toast.error('Please select a country');
            return;
        }

        if (!formData.state) {
            toast.error('Please select a state');
            return;
        }

        const payload = {
            ...formData,
            items: orderItems,
            total: calculateTotal(),
            payment_method: paymentMethod
        };

        console.log('Submitting order:', payload);

        try {
            const result = await placeOrder(payload, token);
            if (result && result.status) {
                toast.success('Order placed successfully!');
                window.dispatchEvent(new CustomEvent('cartUpdated'));
                navigate('/orderhistory'); 
            } else {
                toast.error(result.message || 'Failed to place order');
            }
        } catch (error) {
            console.error('Error placing order:', error);
            toast.error('Failed to place order. Please try again later.');
        }
    };

    useLayoutEffect(() => {
        const timer = setTimeout(() => {
            if (window.animationText) window.animationText();
            if (window.scrollingEffect) window.scrollingEffect();
            if (window.animateImgItem) window.animateImgItem();

            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 100);

        return () => {
            clearTimeout(timer);
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, []);

    return (
        <div className="wrapper position-relative">
            <Header />
            <div className="wrapper position-relative overflow-x-clip">
                <div className="mask mask-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                        <circle cx="400" cy="400" r="325" stroke="url(#a6)" strokeWidth="150" />
                        <defs>
                            <linearGradient id="a6" x1="176" x2="569" y1="70.5" y2="674">
                                <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                                <stop offset="1" stopColor="#fff" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <div className="mask mask-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                        <circle cx="400" cy="400" r="325" stroke="url(#e7)" strokeWidth="150" />
                        <defs>
                            <linearGradient id="e7" x1="176" x2="569" y1="70.5" y2="674">
                                <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                                <stop offset="1" stopColor="#fff" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
            </div>

            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1 className="title">
                            <span className="split-text effect-right">Checkout</span>
                        </h1>
                        <div className="breadkcum">
                            <Link to="/" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right">Home</span>
                            </Link>
                            <span className="dot"></span>
                            <span className="page-breadkcum body-2 fw-7">
                                <span className="split-text effect-right">Checkout</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="main-content">
                <section className="section-team p-team tf-spacing-2">
                    <div className="tf-container">
                        <div className="row rg-30">
                            {/* Billing Details */}
                            <div className="col-lg-7">
                                <div className="checkout-box">
                                    <div className="checkout-title">Billing Details</div>
                                    <form
                                        className="form-contact-us form-billing-us style-bg-dark-2 px-md-15"
                                        method="post"
                                        onSubmit={handleSubmit}
                                        noValidate
                                    >
                                        {/* Name Fields */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="icon-user"></i>
                                                    <input
                                                        type="text"
                                                        name="first_name"
                                                        id="name"
                                                        placeholder="First Name"
                                                        value={formData.first_name}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </fieldset>
                                            </fieldset>

                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="icon-user"></i>
                                                    <input
                                                        type="text"
                                                        name="last_name"
                                                        id="lname"
                                                        placeholder="Last Name"
                                                        value={formData.last_name}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                        {/* Email and Phone */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="icon-email"></i>
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        id="mail"
                                                        placeholder="Email Address"
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </fieldset>
                                            </fieldset>

                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="icon-phone"></i>
                                                    <input
                                                        type="number"
                                                        name="phone"
                                                        id="phone"
                                                        placeholder="Phone Number"
                                                        value={formData.phone}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                        {/* Address */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="fa-regular fa-map"></i>
                                                    <input
                                                        type="text"
                                                        name="address"
                                                        id="address"
                                                        placeholder="Street Address"
                                                        value={formData.address}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                        {/* Zip and City */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="fa-solid fa-map-pin"></i>
                                                    <input
                                                        type="number"
                                                        name="postal_code"
                                                        id="zip"
                                                        placeholder="Zip/Postal Code"
                                                        value={formData.postal_code}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </fieldset>
                                            </fieldset>
{/* 
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="fa-solid fa-city"></i>
                                                    <input
                                                        type="text"
                                                        name="city"
                                                        id="city"
                                                        placeholder="City"
                                                        value={formData.city}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </fieldset>
                                            </fieldset> */}
                                            <fieldset className="item">
                                                <select
                                                    name="country"
                                                    id="country"
                                                    value={formData.country}
                                                    onChange={handleInputChange}
                                                    className="nice-select w-100"
                                                    required
                                                    disabled={loadingCountries}
                                                >
                                                    <option value="">
                                                        {loadingCountries ? 'Loading countries...' : 'Select Country'}
                                                    </option>
                                                    {countries.map(country => (
                                                        <option key={country.id} value={country.id}>
                                                            {country.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </fieldset>
                                        </div>

                                        {/* State and Country Selects */}
                                        <div className="cols mb-37 g-30">
                                            {/* <fieldset className="item">
                                                <select
                                                    name="country"
                                                    id="country"
                                                    value={formData.country}
                                                    onChange={handleInputChange}
                                                    className="nice-select w-100"
                                                    required
                                                    disabled={loadingCountries}
                                                >
                                                    <option value="">
                                                        {loadingCountries ? 'Loading countries...' : 'Select Country'}
                                                    </option>
                                                    {countries.map(country => (
                                                        <option key={country.id} value={country.id}>
                                                            {country.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </fieldset> */}

                                            <fieldset className="item">
                                                <select
                                                    name="state"
                                                    id="state"
                                                    value={formData.state}
                                                    onChange={handleInputChange}
                                                    className="nice-select w-100"
                                                    required
                                                    disabled={!formData.country || loadingStates}
                                                >
                                                    <option value="">
                                                        {loadingStates 
                                                            ? 'Loading states...' 
                                                            : !formData.country 
                                                                ? 'Select country first' 
                                                                : 'Select State'
                                                        }
                                                    </option>
                                                    {states.map(state => (
                                                        <option key={state.id} value={state.id}>
                                                            {state.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </fieldset>


                                            
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="fa-solid fa-city"></i>
                                                    <input
                                                        type="text"
                                                        name="city"
                                                        id="city"
                                                        placeholder="City"
                                                        value={formData.city}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                        {/* Order Notes */}
                                        <fieldset className="">
                                            <textarea
                                                name="order_notes"
                                                id="notes"
                                                placeholder="Order Notes (Optional)"
                                                value={formData.order_notes}
                                                onChange={handleInputChange}
                                            />
                                        </fieldset>
                                    </form>
                                </div>
                            </div>

                            {/* Order Summary */}
                            <div className="col-lg-5">
                                <div className="checkout-box">
                                    <div className="checkout-title">Your Order</div>

                                    <div className="order-summary">
                                        {loading ? (
                                            <div className="text-center py-3">Loading order details...</div>
                                        ) : orderItems.length === 0 ? (
                                            <div className="text-center py-3">Your cart is empty</div>
                                        ) : (
                                            <>
                                                {orderItems.map(item => (
                                                    <div key={item.id} className="order-item">
                                                        <span>{item.name} × {item.quantity}</span>
                                                        <span>{currency}{(Number(item.price) * item.quantity).toLocaleString()}</span>
                                                    </div>
                                                ))}
                                                <div className="order-item">
                                                    <span>Tax ({taxRate}%)</span>
                                                    <span>{currency}{calculateTax().toLocaleString()}</span>
                                                </div>
                                                <div className="order-item total">
                                                    <span>Total</span>
                                                    <span>{currency}{calculateTotal().toLocaleString()}</span>
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    {/* Payment Method */}
                                    <div className="payment-method mt-4">
                                        <label>
                                            <input
                                                type="radio"
                                                name="payment"
                                                checked={paymentMethod === 'cod'}
                                                onChange={() => setPaymentMethod('cod')}
                                            />
                                            <i className="fa-solid fa-money-bill-wave"></i>
                                            Cash on Delivery
                                        </label>
                                    </div>

                                    {/* Place Order Button */}
                                    <button
                                        type="submit"
                                        onClick={handleSubmit}
                                        className="tf-btn style-bg-primary w-full justify-content-center mt-5"
                                    >
                                        <span>Place Order</span>
                                        <i className="icon-arrow-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer />
        </div>
    );
};

export default Checkout;